import Vue from "vue";
import "./plugins/axios";
// import axios from 'axios';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { apiClient } from "@/services/ApiService.js";
import VueSweetalert2 from "vue-sweetalert2";
import swal from "sweetalert2/dist/sweetalert2.all.min.js";
import moment from 'moment';

Vue.config.productionTip = false;

Vue.use(VueSweetalert2);

const HOME_ROUTE = "/tocas/list";
let handlingForbidden = false;

function handleGlobalForbidden(error) {
  if (handlingForbidden || !localStorage.getItem("token")) {
    return;
  }

  handlingForbidden = true;
  store.commit("SET_LOADING", false);

  const payload = error.response && error.response.data ? error.response.data : {};
  if (payload.autorizacion && payload.autorizacion.fecha_revocacion) {
    localStorage.setItem("currentToca", JSON.stringify(payload.autorizacion));
  }

  const currentPath = router.currentRoute.path;
  const alreadyOnHome = currentPath === HOME_ROUTE;

  swal.fire({
    icon: "warning",
    title: "Acceso no permitido",
    text: "No tiene permiso para realizar esta acción.",
    confirmButtonText: alreadyOnHome ? "Aceptar" : "Regresar",
  }).then(() => {
    handlingForbidden = false;
    if (!alreadyOnHome) {
      router.push({ name: "TocasList" });
    }
  });
}

const token = localStorage.getItem("token");
if (token) {
  apiClient.defaults.headers.common["Authorization"] = "Bearer " + token;
}
//else {
//apiClient.defaults.headers["Content-Type"] =
//  "application/x-www-form-urlencoded";
//}

// apiClient.interceptors.response.use(
//   response => {
//     // intercept the global error
//     return response;
//   },
//   function(error) {
//     let originalRequest = error.config;
//     if (error.response.status === 401 && !originalRequest._retry) {
//       // if the error is 401 and hasent already been retried
//       console.log("intercepta", error);
//       store.commit("SET_LOADING", false);
//       store.commit("AUTH_LOGOUT");
//       router.push("/login");

//       // originalRequest._retry = true // now it can be retried
//     }
//     if (error.response.status === 404 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       // window.location.href = '/'
//       return;
//     }
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );

//Interceptor para VER LOS HEADERS ENVIADOS en cada solicitud
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
if (token) {
  config.headers["Authorization"] = `Bearer ${token}`;
}

  //console.log("📡 Enviando solicitud a:", config.url);
  //console.log("🚀 Headers enviados:", config.headers);

  if (config.headers.Authorization) {
    //console.log("🔑 Token Bearer enviado:", config.headers.Authorization);
  } else {
    console.warn("⚠️ No se está enviando un TB");
  }

  //console.log("🚀 Headers enviados:", config.headers);
  return config;
}, (error) => {
  console.error("❌ Error en solicitud:", error);
  return Promise.reject(error);
});

apiClient.interceptors.response.use(
  response => {
    // intercept the global error
    // console.log("respuesta global", response)
    return response;
  },
  function(error) {

    let originalRequest = error.config;
    //console.log("originalRequest", originalRequest);
    //console.log("error response", error.response);


    if (error.response.status === 401 && !originalRequest._retry) {


      // Verificar si la solicitud es de login
      if (originalRequest.url.includes("/login")) {
       //lo mando al componente de Signin que inicia la llmada
        // No redirigir en caso de login
        return Promise.reject(error);
      }

      // if the error is 401 and hasent already been retried
      //console.log("intercept por aqui en 401");
      //store.commit("SET_LOADING", false);
      //store.commit("AUTH_LOGOUT");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("currentToca");

      delete axios.defaults.headers.common["Authorization"];

      //this.$router.push({ name: 'signin' }); comentado porqu eno redirigia
      //correctamente al no haber token

      // window.location.href = '/login' //en prod
      router.push("/login");



      // originalRequest._retry = true // now it can be retried
    }
    if (error.response.status === 403 && localStorage.getItem("token")) {
      handleGlobalForbidden(error);
      return Promise.reject(error);
    }
    if (error.response.status === 404 && !originalRequest._retry) {
      originalRequest._retry = true;
      // window.location.href = '/'
      return;
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('LL hh:mm A')
    }
});
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('ll')
    }
});
Vue.filter('formatDays', function(value) {
    if (value) {
        return moment(String(value)).fromNow();
    }
});
moment.locale('es-mx');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
